import { render } from "./B2bPageAccountingCloseDraft.vue?vue&type=template&id=5185ae56&scoped=true&lang=pug"
import script from "./B2bPageAccountingCloseDraft.vue?vue&type=script&lang=js"
export * from "./B2bPageAccountingCloseDraft.vue?vue&type=script&lang=js"

import "./B2bPageAccountingCloseDraft.vue?vue&type=style&index=0&id=5185ae56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5185ae56"]])

export default __exports__